{
  "loading": "Loading",
  "howToPlay": "How to Play:",
  "howToPlayControls": "- Arrows: Movement\n- A Key: Action",
  "pressToStart": "Press A or tap the screen to start",
  "wardrobe1": "My clothes are here, let's see if I can find my red t-shirt ...",
  "wardrobe2": "Here is the t-shirt! I also take the rest of the things ... I already have everything!",
  "wardrobe3": "I've already picked up my clothes!",
  "wardrobeNoClothes": "Items and more items of clothing ... but there is nothing here that is mine!",
  "bathroom1": "It's time to take a shower!",
  "bathroomFail1": "Before I take a shower, I need to grab the clothes I’m going to put on. My clothes are in one of the closets in the room.",
  "likeNew": "I'm ready. I feel so much better!",
  "wakeUpFreeman": "Wake up, Mister Freeman. Wake up and... smell the ashes...",
  "wakeUpAlbert": "... I mean, Albert! Wake up or you'll be late for work!",
  "ellipsis": "...",
  "ellipsisX2": "......",
  "rightNow": "Yeah ... I'm getting up right now.",
  "walkCobi": "I’m going to walk Cobi, and when I get back I’ll be going to work too. See you later!",
  "bark": "Woof!",
  "prepare": "Well, I have to get ready: First I have to take a shower and then I have to grab my laptop before I go out to work.",
  "prepare2": "Use the arrows to control the character and the 'A' key to interact with objects. With the 'M' key you can open the menu, which is also controlled with the arrows and 'A'.",
  "prepare3": "The 'S' key can be used to toggle the sound. Finally, with the letter 'F' you can toggle the full screen mode.",
  "prepare4": "It's your chance, go around the maps and the game menu to find out more about me!",
  "shelves1": "There are books of all kinds here. What I like to read the most is fantasy and science fiction literature, but I can read other types of books without any problems.",
  "shelves2": "Video games and more video games. They are one of my favorite hobbies. My first console was the Atari 2600, and since then I have continued to play both console and computer games.",
  "shelves3": "Here are some books on technology and methodology. I like to learn new things, either by reading or developing projects, like this game you are playing right now :)",
  "shelves4": "Here are some figures. I'm not a collector, but I do occasionally like to acquire figures on topics I like.",
  "noeDesktop": "Noe's desk. I have no power here.",
  "albertDesktop": "My desk. I spend many hours here! My work laptop is here, I grab it, I need it to work at the office.",
  "albertDesktopFail": "My desk. I spend many hours here! My work laptop is here, but before I can grab it, I have to take a shower.",
  "albertDesktop2": "My desk. I spend many hours here! ",
  "tv": "The TV! This is where we watch series and movies. And of course, I also play video games.",
  "couch": "I don’t have time to sit down!",
  "coffeeMachine1": "What would I do without the coffee maker? Since I'm here, I'll have some coffee ...",
  "coffeeMachine2": "How good it is! I'm at my best now!",
  "coffeeMachine3": "I’ll make coffee to take with me, you never know when it might be needed.",
  "coffeeMachine4": "Better not drink too much coffee, ha, ha, ha!",
  "microwave": "The microwave, I couldn't live without it!",
  "fridge": "The fridge is almost empty ... We have to go to buy food!",
  "doorFail": "I'm not ready to go out yet ...",
  "door": "Time to go to the office!",
  "albert": "Albert",
  "noe": "Noe",
  "cobi": "Cobi",
  "officeIntro": "Later at the office ...",
  "goToDesk": "Before I start working, I can talk to my workmates and look around the office. To start working, I have to go to my desk, which is empty right now.",
  "mf": "Miquel",
  "boss": "Raúl",
  "rs": "Raquel",
  "cc": "Carlos",
  "sn": "Sid",
  "se": "Silvia",
  "rm": "Rafa",
  "ef": "Edgar",
  "ej": "Enric",
  "fs": "Fonsi",
  "wg": "Wilder",
  "ja": "Jack",
  "yf": "Yaiza",
  "mf1": "Albert, Goooood moooorning! I’m playing tennis. Do you want to play? Let's see who wins!",
  "mf2": "If you want to play, go to the arcade and press the action button.",
  "mf3": "After this exciting game, it's time to work!",
  "mf4": "I will check that the performance of the new functionality we are developing is correct.",
  "arcade1": "Let's play!",
  "arcade2": "I've played enough for today!",
  "pairProgrammingAdded": "After the game, you feel super motivated to work with the team! As a result, you will be able to do pair programming during work.",
  "mfWon": "I won! My training has paid off. Tomorrow we'll play again, now it's time to work!",
  "mfLost": "I lost! I'll win the next game, you'll see! Let's play again tomorrow, now it's time to work!",
  "rr1": "Good morning. I am reading some books for a training I am preparing. I hope you like it!",
  "cc1": "Hello! I am monitoring how our servers are behaving after the last deploy to production.",
  "cc2": "It is important to see that everything works properly!",
  "rs1": "Good morning!! Today I started a new task, and before I continue I want to reorganize the code a bit.",
  "rs2": "The code must be kept clean and polished!",
  "sn1": "Good morning, how are you? You caught me prioritizing the tasks we will do in the next sprints.",
  "sn2": "You will see how interesting they are!",
  "se1": "Hello, good Morning. I'm researching some bugs we have in the system. It is vital to offer a reliable service!",
  "rm1": "Hello mate! I am improving the execution time of automated tests. Test feedback should be fast!",
  "ef1": "Hey! I’ve been given the new design of the user profile page, and I’m looking how to adapt it to HTML.",
  "ef2": "The page structure is important!",
  "ej1": "Hey! What's up? I am improving the log system to have more information if the user has any",
  "ej2": "problem. We need to know what happens in our app!",
  "fs1": "Yep! Right now I am developing unit tests. It is essential to have our application well tested!",
  "fs2": "I give you a donut from my secret stash, but don't tell anyone!",
  "wg1": "Hi, how are you? I am validating that the tasks that have been developed work well.",
  "wg2": "The quality of the software must be assured!",
  "ja1": "Good morning, Albert! I am answering questions from users. Good customer service is very important!",
  "yf1": "Hello, Albert! If you need help with any topic of work, here I am!",
  "officeBathroom1": "Right now I don’t have to go to the bathroom!",
  "officeStuff1": "Here we have office supplies, nothing interesting.",
  "tv1": "We use this TV to make presentations of different types, such as presentations of new projects.",
  "library1": "There are quite a few books dedicated to software development in case we need to make any inquiries.",
  "library2": "I will take the Functional-Light-JavaScript book, I want to read some concepts that will help me solve the task I am doing!",
  "library3": "I already have the book!",
  "officeMicrowave1": "Obviously, this is where we heat the food!",
  "officeCoffeeMachine1": "I will make coffee to drink while I work. Energy!",
  "officeCoffeeMachine2": "At the moment I have enough coffee!",
  "officeFridge1": "Inside this fridge there is everything, not like in my house. Lots of delicious stuff!",
  "officeFridge2": "Come on! I will take a donut, which they always come to taste.",
  "lockers1": "Inside this closet we can leave our belongings.",
  "diningTable1": "The table for lunch. This is where we meet every day and have a good time chatting to each other while we eat.",
  "meetingRoom1": "All kinds of meetings are held in this room, such as sprint planning and retrospectives.",
  "myDesk1": "This is my desktop. Maybe I can take a walk before work. If you want me to start working, re-examine the desktop!",
  "myDesk2": "Time to open the laptop and get started!",
  "clothes": "Clothes",
  "coffee_cup": "Coffee",
  "coffeeDescription": "(+25 HP)",
  "flj_book": "F-L JS Book",
  "fljBookDescription": "(+1 Skill)",
  "notebook": "Notebook",
  "donut": "Donut",
  "donutDescription": "(+50 HP)",
  "about": "About",
  "skills": "Skills",
  "items": "Items",
  "experience": "Experience →",
  "projects": "Projects →",
  "name": "Name:",
  "age": "Age:",
  "quantity": "Quantity:",
  "aboutMe": "Born in Barcelona. I finished Computer Engineering in 2010, and since then I have worked as a software developer. I currently work with PHP and JavaScript.",
  "webPerf": "Web Perf.",
  "mailtrackTitle": "Fullstack Engineer at Mailtrack",
  "mailtrackDates": "July 2018 - Nowadays",
  "mailtrackDescription": "Mailtrack's product is a Google Chrome extension that allows you to track emails in Gmail. On the one hand I work in backend services, developed with PHP and Node.js. On the other hand I work on the extension, developed with TypeScript, CSS and HTML. I also do some system tasks, like setting up Docker or services in AWS.",
  "atrapaloLeadTitle": "Lead Frontend Developer at Atrápalo",
  "atrapaloLeadDates": "July 2017 - June 2018",
  "atrapaloLeadDescription": "I worked as a Tech Lead on the company’s Frontend team. My duties were on the one hand to manage the team and on the other to guide and develop the frontend architecture of the website.",
  "atrapaloBackendTitle": "Software Developer at Atrápalo",
  "atrapaloBackendDates": "January 2014 - July 2017",
  "atrapaloBackendDescription": "I worked as a PHP developer on a complex system with multiple technologies: RabbitMQ, Elastic, MySQL and Redis among others.",
  "lcfibTitle": "Internship - Developer at LCFIB",
  "lcfibDates": "September 2008 - July 2010",
  "lcfibDescription": "Here I worked with different technologies. On the one hand, I developed different projects with J2EE. I also worked with Oracle Forms and Oracle Reports. Finally, I worked with PHP and MySQL on the FIB video portal.",
  "carverTitle": "J2EE Developer at Carver Advanced Systems",
  "carverDates": "September 2010 - January 2014",
  "carverDescription": "I worked as a J2EE and Oracle SQL developer making an insurance application. The application managed and priced insurance from different areas.",
  "nsbTitle": "NoSoloBits Site",
  "nsbDescription": "NoSoloBits is a website dedicated to retro games. The backend part is made with PHP and MySQL. The frontend part is made with HTML, JS and SASS, compiled with Webpack.",
  "easytimerTitle": "Easytimer.js",
  "easytimerDescription": "Easytimer.js is a small utility developed with JS that allows you to easily manage a stopwatch and countdown.",
  "gameTitle": "This Video Game!",
  "gameDescription": "The video game you're playing right now. I stepped out of my comfort zone to do so, as I am not a video game designer. The result has been a simple, short game, but I think it’s still a good cover letter. I put a lot of passion into it, I hope you like it!",
  "code": "Code",
  "codePageDescription": "Write code to attack the bug.",
  "enemyDamaged": "Your code has dealt {{ damage }} points of damage to the bug.",
  "playerDamaged": "The bug has dealt you {{ damage }} points of damage.",
  "coffeeEffect": "You drink your coffee and feel much more energetic. The coffee has made you recover {{ hp }} health points.",
  "donutEffect": "You eat the donut with desire! The donut makes you recover {{hp}} health points.",
  "bookEffect": "You read a chapter that makes it clearer how to apply Functional Programming. Now you have a new skill!",
  "debug": "Debug",
  "debugDescription": "(Attack ↑)",
  "pairProgramming": "Pair Programming",
  "pairProgrammingDescription": "(Def ↑)",
  "functionalProgramming": "Functional Prog.",
  "functionalProgrammingDescription": "(S. Attack)",
  "unitTesting": "Unit Testing",
  "unitTestingDescription": "(Extra Turn)",
  "battleTimeToWork": "Time to work! We have to finish a pretty important task that we have to deliver tomorrow.",
  "battleTimeToWork2": "It seems that everything is perfect ...",
  "battleSomethingIsWrong": "Oh no! Something is wrong!",
  "battleBugFound": "We found a nasty bug! We need to get rid of him before it's too late!",
  "battleTutorial": "To kill the bug I can do 3 things in the menu: Write code, use a skill or use items.",
  "attackPowerUpDescription": "Debugging helps you identify problems, increasing your next 2 attacks!",
  "defensePowerUpDescription": "Doing pair programming makes you much more effective, increasing defense for 2 turns!",
  "extraTurnPowerUpDescription": "Doing refactoring and unit testing makes you detect uncontrolled cases, winning 2 extra turns!",
  "fired": "You are fired",
  "refresh": "Refresh the page if you want to play again!",
  "tip": "Tip: Search for objects to use in the battle",
  "endingStory": "After defeating the dangerous bug, you realize that you are cut out for hunting down all these beasts that endanger the software of the whole world. Without hesitation, you get down to work fighting with all your might, even reaching hell itself, where these evil beings originate. The legend of the Bug Slayer has begun ...",
  "thankYou": "Thank you for playing!"
}
